export default "__VITE_ASSET__45e517a5__"